import React, { ReactNode, useContext, useMemo } from "react"
import { DropdownContext } from "./Dropdown"
import AnimateHeight from "react-animate-height"

interface iDropdownBody {
  children: ReactNode
  className?: string
  contentClassName?: string
}

const DropdownBody: React.FC<iDropdownBody> = ({
  children,
  className,
  contentClassName,
}) => {
  const { isOpen } = useContext(DropdownContext)

  return useMemo(
    () => (
      <AnimateHeight
        contentClassName={contentClassName}
        className={className}
        duration={300}
        height={isOpen ? "auto" : 0}
      >
        {children}
      </AnimateHeight>
    ),
    [isOpen],
  )
}

export default DropdownBody
